module.exports = __webpack_public_path__ + "static/media/flyrest-1.496303f5.jpg";